import React, {Component} from 'react';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import classNames from 'classnames';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import breadcrumbClickHandler from './events';
import {selector} from '../../utils/wdio-selectors';

class BreadcrumbsComponent extends Component {
    render() {
        const {breadcrumbs, isInHeader, theme, isRefined} = this.props;
        const themeClass = theme === 'vrbo' ? 'vrbo' : '';
        const breadcrumbsClasses = classNames('breadcrumbs', {
            [`header ${themeClass}`]: isInHeader,
            'container module': !isInHeader,
            'module--xs-margin': !isInHeader && !isRefined,
        });

        return breadcrumbs ? (
            <div
                className={breadcrumbsClasses}
                data-wdio={selector.destinationBreadcrum}
            >
                <EdapViewTracker
                    eventData={{
                        action_location: 'destination-breadcrumb',
                        position_fired: 'top',
                    }}
                />
                <Breadcrumbs
                    crumbs={breadcrumbs}
                    isLastCrumbLinked
                    onClickCrumbName={breadcrumbClickHandler(breadcrumbs)}
                />
                <EdapViewTracker
                    eventData={{
                        action_location: 'destination-breadcrumb',
                        position_fired: 'bottom',
                    }}
                />
            </div>
        ) : null;
    }
}

export default BreadcrumbsComponent;
